import React from 'react';
import move from 'lodash-move';
import { set } from 'lodash/fp';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InputGroup, Input, List } from 'rsuite';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Image from '../../../../../components/reservations/Image';
import StoplightIndicator from '../../../../../components/StoplightIndicator';
import { parseInt } from '../../../../../helpers/utils';
import { LinkedItemIcon } from '../../../../../components/reservations/PicklistItem/elements';

const StyledInputGroup = styled(InputGroup)`
  &:not(.rs-input-group-inside) {
    position: relative;
    border: none;
    border-radius: 0;
    > .rs-input {
      border-top: 1px solid #86cce7;
      border-bottom: 1px solid #86cce7;
    }
    > :first-child {
      color: #fff;
      background-color: #86cce7;
      border-top-left-radius: 0;
    }
    > :last-child {
      color: #fff;
      background-color: #86cce7;
      border-top-right-radius: 0;
    }
  }
`;

const StyledList = styled(List)`
  padding: 10px;
  text-align: center;
`;

const Item = styled(List.Item)`
  padding: 0;
  margin: 8px 16px;
  width: 140px;
  box-shadow: none;
  display: inline-block;
  border: 2px solid #efefef;
  border-radius: 8px;
  vertical-align: top;
  &:hover {
    cursor: move;
  }
  .rs-list-item-content {
    text-align: center;
    font-weight: 500;
    > p {
      margin: 12px 0;
    }
  }
`;

const ItemPhoto = styled(Image)`
  margin-top: 10px;
  border-radius: 5px;
`;

const HealthIndicator = styled(StoplightIndicator)`
  top: -7px;
  left: -7px;
  position: absolute;
  font-size: 18px;
`;

const SortableItem = SortableElement(
  ({ name, photo, healthLevel, inventorySnapshot }) => (
    <Item>
      {parseInt(healthLevel) > 0 && <HealthIndicator value={healthLevel} />}
      {inventorySnapshot && (
        <LinkedItemIcon inventorySnapshot={inventorySnapshot} />
      )}
      {photo && <ItemPhoto alt="" image={photo} width={64} />}
      <p>{name}</p>
      <StyledInputGroup>
        <InputGroup.Addon disabled>&nbsp;&ndash;&nbsp;</InputGroup.Addon>
        <Input value={0} style={{ textAlign: 'center' }} readOnly />
        <InputGroup.Addon disabled>&nbsp;+&nbsp;</InputGroup.Addon>
      </StyledInputGroup>
    </Item>
  )
);

const SortableList = SortableContainer(({ items }) => (
  <StyledList>
    {items.map(
      ({ itemId, name, photo, healthLevel, inventorySnapshot }, index) => (
        <SortableItem
          key={`item-${itemId}`}
          index={index}
          name={name}
          photo={photo}
          healthLevel={healthLevel}
          inventorySnapshot={inventorySnapshot}
        />
      )
    )}
  </StyledList>
));

const SortableItems = ({ categoryId, data, onSortEnd }) => {
  const handleSortEnd = ({ oldIndex, newIndex }) => {
    const items = move(data, oldIndex, newIndex).map((each, i) =>
      set('position', i + 1, each)
    );
    onSortEnd({ categoryId, items });
  };
  return <SortableList axis="xy" items={data} onSortEnd={handleSortEnd} />;
};

SortableItems.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  categoryId: PropTypes.string.isRequired,
  onSortEnd: PropTypes.func.isRequired
};

export default SortableItems;
